import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ResultPageSkeleton from "../../../Loading/ResultPageSkeleton";
import digitConverter from "../../../utils/digitConverter";
import thConverter from "../../../utils/thConverter";
import NoDataFoundModal from "../../Aqeedah/NoDataFoundModal";
import AsmaulHusnaAdminAccessRow from "./AsmaulHusnaAdminAccessRow";
import ExportAttendace from "./ExportAttendace";

export default function AsmaulHusnaAdminAccess() {
  const params = useParams();
  const [students, setStudents] = useState([]); // Store students locally
  const [filteredStudents, setFilteredStudents] = useState([]); // For search results
  const [loading, setLoading] = useState(true);
  const [duaData, setduaData] = useState([]);
  const [module_no, setModule_no] = useState(0);
  const [duaLength, setDuaLength] = useState(0);
  const [updateSignal, setUpdateSignal] = useState(0);

  const batchNo = parseInt(params.batch);

  // Fetch student data only once
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_API}/asmaulhusna/${batchNo}`
        );
        setStudents(data); // Store students in state
        setFilteredStudents(data); // Initially, show all students
        setLoading(false);
      } catch (error) {
        console.error("Error fetching student data:", error);
        setLoading(false);
      }
    };
    fetchData();
  }, [batchNo, module_no, updateSignal]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/asmaulHusnaList.json"); // Assuming data.json is in the public folder
        const data = await response.json();
        setduaData(data);
      } catch (error) {
        console.error("Error fetching JSON data:", error);
      }
    };

    fetchData();
  }, []);

  // Handle search input and filter students
  const searchByName = (e) => {
    e.preventDefault();
    const name = e.target.name.value.toLowerCase();

    const filtered = students.filter((student) =>
      student.name.toLowerCase().includes(name)
    );

    if (filtered.length === 0) {
      document.getElementById("my_modal_3").showModal();
      return;
      // setNoDataModalVisible(true);
    }
    setFilteredStudents(filtered); // Update the filtered list
  };
  if (loading) {
    // return <Loading />;
    return (
      <div className="my-10">
        <p className="text-center text-2xl">
          আল আসমাউল হুসনা কোর্স - ব্যাচ {digitConverter(batchNo)}
          {thConverter(batchNo)}
        </p>
        <ResultPageSkeleton />
      </div>
    );
  }

  const selectChange = (e) => {
    const module = parseInt(e.split("-")[0].trim()) - 1;
    setModule_no(module);
    setDuaLength(e.split("-").length - 1);
  };

  return (
    <div className="my-10">
      <div className="mx-0 flex justify-center gap-2">
        <p className="text-center">
          <span> আল আসমাউল হুসনা কোর্স - ব্যাচ {digitConverter(batchNo)}</span>
        </p>
        <div>
          <ExportAttendace
            students_record={students}
            course={"Al Asmaul Husna"}
          />
        </div>
      </div>

      <section className="flex justify-center">
        <fieldset className="fieldset w-5/6">
          <legend className="fieldset-legend">মডিউউল সিলেক্ট করুন</legend>
          <select
            defaultValue="মডিউউল সিলেক্ট করুন"
            className="select w-full mt-5 select-accent"
            onChange={(e) => selectChange(e.target.value)}
          >
            {/* <option disabled={true}>মডিউউল সিলেক্ট করুন</option> */}
            {duaData.map((dua_module, index) => (
              <option key={index}>
                {index + 1} - {dua_module.join(" - ")}
              </option>
            ))}
            {/* <option>FireFox</option>
            <option>Safari</option> */}
          </select>
          {/* <span className="fieldset-label">Optional</span> */}
        </fieldset>
      </section>

      <div className="text-center">
        <form onSubmit={searchByName}>
          <div className="form-control my-10">
            <div className="input-group flex justify-center">
              <input
                name="name"
                type="text"
                placeholder="আপনার নাম লিখে সার্চ করুন"
                className="input input-bordered mr-2 w-4/5"
              />
              {
                <button type="submit" className="btn btn-primary btn-circle">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              }
            </div>
          </div>
        </form>
      </div>

      <div className="overflow-x-auto w-10/12 mx-auto">
        <table className="table w-full">
          <thead>
            <tr>
              <th>SN</th>
              <th>Name</th>
              <th>Module {module_no + 1}</th>
              <th>Pofile</th>
              <th>Gems</th>
            </tr>
          </thead>
          <tbody>
            {filteredStudents?.map((student) => (
              <AsmaulHusnaAdminAccessRow
                key={student.sn}
                module_no={module_no}
                student={student}
                batch={batchNo}
                completion={duaLength}
                updateSignal={updateSignal}
                setUpdateSignal={setUpdateSignal}
              ></AsmaulHusnaAdminAccessRow>
            ))}
          </tbody>
        </table>
      </div>

      <div>
        <NoDataFoundModal></NoDataFoundModal>
      </div>
    </div>
  );
}
